<main class="main">
  <router-outlet></router-outlet>
</main> 